export default "__VITE_PUBLIC_ASSET__66ce17af__"